import { render, staticRenderFns } from "./DashboardImagesGallery.vue?vue&type=template&id=4e6c1de7&scoped=true"
import script from "./DashboardImagesGallery.vue?vue&type=script&lang=js"
export * from "./DashboardImagesGallery.vue?vue&type=script&lang=js"
import style0 from "./DashboardImagesGallery.vue?vue&type=style&index=0&id=4e6c1de7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c1de7",
  null
  
)

export default component.exports